export abstract class MaterialsEvent {}

export class MaterialsLoad extends MaterialsEvent {}
